import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createMemoStyles(({ spacing, pricingPalette }: PricingAppTheme) => ({
  Features: {
    padding: [spacing[4], spacing[6], 0],
  },
  FeatureList: {
    listStyle: 'none',
    fontSize: 13,
    lineHeight: 1.2,
    color: pricingPalette.colors.charcoal,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: [spacing[4], 'auto', 0],
    width: '100%',
  },
  FeatureItem: {
    padding: [6, 0, 6],
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word',

    '& svg': {
      width: 16,
      marginRight: spacing[3],
    },
  },
}));
